import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { ProductStatus } from '../ProductStatus/ProductStatus'
import { ProductQuantity } from '../ProductQuantity'
import { OptionComponent } from '@ztechapps/webui.input'
import React from 'react'
import { truncate } from '@ztechapps/common.utils'

export const OptionSimple = ({ data, ...rest }) => {
  const productName = data?.name
  const label = (
    <HorizontalStack className="justify-content-between">
      <div>
        <ShowIf condition={!data?.__isCreate}>
          <HorizontalStack gap={1}>
            <div>
              <ProductStatus value={data?.status} />
              <span className="fw-bold">{data?.code}</span>
            </div>
            <ShowIf condition={!!productName}>
              <div>→</div>
              <small>{truncate(productName, 150)}</small>
            </ShowIf>
          </HorizontalStack>
        </ShowIf>
        <ShowIf condition={data?.__isCreate}>
          <span>{data?.optionLabel}</span>
        </ShowIf>
      </div>
      <div>
        <ProductQuantity
          hasSubComponents={data?.hasSubComponents}
          quantityOnHand={data?.inventory?.quantityOnHand}
          requiredComputedQuantityOnHand={data?.requiredComputedQuantityOnHand}
          computedQuantityOnHand={data?.computedQuantityOnHand}
          baseUomSymbol={data?.baseUom?.symbol}
          decimalPrecision={data?.unitOfMeasurePrecision}
        />
      </div>
    </HorizontalStack>
  )
  return <OptionComponent {...{ ...rest, data }} label={label} />
}
